import inventoryText from "./inventoryI18n.js";
import React, { useState, useEffect, useContext } from "react";
import EditInventory from "./InventoryEdit";
import Modal from "react-bootstrap/Modal";

import { API_URL } from "../components/api";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
} from "@mui/x-data-grid";
import AuthContext from "../context/AuthContext";
import "./InventoryTable.css";
import ExcelSVG from "../../ExcelSVG.svg";
import FilterSVG from "../../FilterSVG.svg";
import * as XLSX from "xlsx";
import Button from "react-bootstrap/Button";
//For API Requests
import axios from "axios";

function InventoryTable() {
  const [data, setData] = useState([]);
  const [showo, setShowo] = useState(false);
  const [dashoo, setDasho] = useState(false);

  const [loading, setLoading] = useState(true);

  const handleshowo = () => setShowo(true);
  const handleedit = () => setShowo(false);

  const showoDash = () => setDasho(true);
  const handledash = () => setDasho(false);

  const [searchQuery, setSearchQuery] = useState("");
  const { user } = useContext(AuthContext);
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));

  const [DealerDetails, setDealerDetails] = useState({
    inventory_id: 0,
    product: "",
    product_id: "",
    quantity: "",
    warehouse_id: "",
    warehouse: "",
  });

  const [filters, setFilters] = useState({
    product: "",
    description: "",
    category: "",
    quantity: "",
  });
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [gridFilterModel, setGridFilterModel] = useState({
    items: [],
  });

  const [searchInput, setSearchInput] = useState(""); // To capture search input

  // NEW: State to track column visibility
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
  const [searchFilterTimeout, setSearchFilterTimeout] = useState(null);

  const updateDealerDetails = (details) => {
    setDealerDetails(details);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const response = await axios.get(`${API_URL}/inventory/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200) {
          setData(response.data);
          console.log(response.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [user.username]);

  const columns = [
    {
      field: "product_name",
      headerName: inventoryText("inventory.ProductName"),
      flex: 2,
      minWidth: 150,
    },
    {
      field: "description",
      headerName: inventoryText("inventory.Description"),
      flex: 1,
      minWidth: 80,
    },
    {
      field: "category_name",
      headerName: inventoryText("inventory.Category"),
      flex: 1,
      minWidth: 80,
    },
    {
      field: "total_quantity",
      headerName: inventoryText("inventory.Quantity"),
      flex: 1,
      minWidth: 80,
    },
  ];

  const getRowId = (row) => row.product_id;

  // Create a delayed search filter function
  const delaySearchFilter = (input) => {
    setSearchQuery(input);
  };

  useEffect(() => {
    // Save "searchValue" value before clearing other session storage items
    const searchValue = sessionStorage.getItem("searchInventory");

    // Clear all session storage items except "searchValue"
    Object.keys(sessionStorage).forEach((key) => {
      if (key !== "searchInventory") {
        sessionStorage.removeItem(key);
      }
    });

    // Restore "searchValue" value if needed
    if (searchValue) {
      sessionStorage.setItem("searchInventory", searchValue);
      setSearchQuery(searchValue);
      setSearchInput(searchValue);
    }
  }, []);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchInput(query);
    sessionStorage.setItem("searchInventory", query);

    if (searchFilterTimeout) {
      clearTimeout(searchFilterTimeout);
    }

    const newTimeout = setTimeout(() => {
      delaySearchFilter(query);
    }, 100);
    setSearchFilterTimeout(newTimeout);
  };

  // IMPROVED: Combined filtering logic that works for both display AND export
  const filteredRows = data.filter((row) => {
    // Apply search query filter
    const searchMatch = searchQuery
      .split(" ")
      .every((word) =>
        Object.values(row).some((value) =>
          String(value).toLowerCase().includes(word.toLowerCase().trim())
        )
      );

    // Apply modal filters
    const modalFilterMatch = Object.keys(filters).every((key) => {
      if (!filters[key]) return true;

      if (key === "connectivity_dependent") {
        const filterValue = filters[key].toLowerCase();
        if (row.connectivity === "Fiber") {
          return (row.code || "").toLowerCase().includes(filterValue);
        } else if (row.connectivity === "Wireless") {
          return (row.name || "").toLowerCase().includes(filterValue);
        }
        return false;
      }

      const rowValue = String(row[key] || "").toLowerCase();
      const filterValue = String(filters[key]).toLowerCase();
      return rowValue.includes(filterValue);
    });

    // Apply DataGrid filters
    const gridFilterMatch = gridFilterModel.items.every((filterItem) => {
      if (!filterItem.value) return true;

      const cellValue = row[filterItem.field];
      const filterValue = filterItem.value;

      switch (filterItem.operator) {
        case "contains":
          return String(cellValue || "")
            .toLowerCase()
            .includes(String(filterValue).toLowerCase());
        case "equals":
          return String(cellValue || "") === String(filterValue);
        case "startsWith":
          return String(cellValue || "")
            .toLowerCase()
            .startsWith(String(filterValue).toLowerCase());
        case "endsWith":
          return String(cellValue || "")
            .toLowerCase()
            .endsWith(String(filterValue).toLowerCase());
        default:
          return true;
      }
    });

    return searchMatch && modalFilterMatch && gridFilterMatch;
  });

  const handleFilterChange = (field, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [field]: value,
    }));
  };

  // Define the column headers mapping
  const columnHeaders = {
    product_name: "Product Name",
    description: "Description",
    category_name: "Category",
    total_quantity: "Total Quantity",
  };

  // Format date fields properly for export — e.g. "21/02/2025 10:25:52 AM"
  const formatDateForExport = (dateValue) => {
    if (!dateValue) return "";
    const date = new Date(dateValue);

    // Format as DD/MM/YYYY HH:MM:SS AM/PM
    const formattedDate = date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    // Ensure consistent spacing before AM/PM
    return formattedDate.replace(" am", " AM").replace(" pm", " PM");
  };

  /// Corrected: Transform rows respecting column visibility
  const transformRowsForExport = (rows) => {
    return rows.map((row) => {
      const transformedRow = {};

      Object.keys(columnHeaders).forEach((field) => {
        // Only export if column is visible
        if (columnVisibilityModel[field] !== false) {
          const headerName = columnHeaders[field];

          // Default: use the value or empty string
          transformedRow[headerName] = row[field] ?? "";
        }
      });

      return transformedRow;
    });
  };

  // IMPROVED: Export function that uses the already-filtered rows
  const handleExportToExcel = () => {
    console.log("Exporting data...");
    console.log("Total data rows:", data.length);
    console.log("Filtered rows:", filteredRows.length);
    console.log("Active filters:", {
      search: searchQuery,
      modalFilters: filters,
      gridFilters: gridFilterModel.items,
    });
    console.log("Column visibility:", columnVisibilityModel);

    // Always use filteredRows which has ALL filters applied
    const transformedRows = transformRowsForExport(filteredRows);

    console.log("Rows to export:", transformedRows.length);

    const worksheet = XLSX.utils.json_to_sheet(transformedRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Inventory");
    XLSX.writeFile(workbook, "Inventory.xlsx");
  };

  const [isPressed, setIsPressed] = useState(false);

  const handleExportClick = () => {
    setIsPressed(true);
    handleExportToExcel();
    setTimeout(() => {
      setIsPressed(false);
    }, 200);
  };

  const CustomToolbar = () => (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <Button
        onClick={() => setShowFilterModal(true)}
        variant="outline-primary"
        style={{
          border: "none",
        }}
      >
        <img
          src={FilterSVG}
          alt="Filter Icon"
          style={{
            color: "white",
            width: "18px",
            marginRight: "8px",
            filter: "invert(0)", // keep black icon
          }}
        />{inventoryText("inventory.Filter")}</Button>
      {/*<GridToolbarFilterButton />*/}
      <GridToolbarExport />
      <Button
        onClick={handleExportClick}
        variant="outline-success"
        style={{
          display: "flex",
          alignItems: "center",
          padding: "5px 10px",
          fontSize: "14px",
          border: "none",
          backgroundColor: isPressed ? "white" : "transparent",
          color: isPressed ? "black" : "#007bff",
          cursor: "pointer",
        }}
      >
        <img
          src={ExcelSVG}
          alt="Excel Icon"
          style={{
            width: "20px",
            marginRight: "8px",
            filter: isPressed ? "invert(0)" : "invert(1)",
          }}
        />
        Excel
      </Button>
    </GridToolbarContainer>
  );

  return (
    <div className="ClientTable">
      <style>{`
        .MuiDataGrid-panelWrapper {
          background: #122632 !important;
        }
      `}</style>
      <input
        type="text"
        placeholder={inventoryText("inventory.Search")}
        value={searchInput}
        onChange={handleSearchChange}
        className="search-client"
      />
      {!loading && data.length > 0 && (
        <div style={{ height: 520, width: "100%" }}>
          <DataGrid
            rows={filteredRows}
            columns={columns}
            getRowId={getRowId}
            filterModel={gridFilterModel}
            onFilterModelChange={(newModel) => setGridFilterModel(newModel)}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
            components={{
              Toolbar: CustomToolbar,
            }}
            rowsPerPageOptions={[10, 100, 1000]}
            pagination
            disableSelectionOnClick
          />
        </div>
      )}
      <Modal
        show={showo}
        onHide={handleedit}
        dialogClassName="inventory-edit-dialog"
      >
        <Modal.Header closeButton>
          <Modal.Title>{inventoryText("inventory.Edit")}</Modal.Title>
        </Modal.Header>
        <EditInventory
          closeModal={handleedit}
          inventory={DealerDetails.inventory_id}
          warehouse={DealerDetails.warehouse}
          product={DealerDetails.product}
          quantity={DealerDetails.quantity}
        />
      </Modal>
      <Modal show={showFilterModal} onHide={() => setShowFilterModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{inventoryText("inventory.Filters")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {columns
            .filter((col) => col.field !== "actions")
            .map((col) => (
              <div key={col.field} className="filter">
                <label>{col.headerName}</label>
                <input
                  type="text"
                  placeholder={`Filter by ${col.headerName}`}
                  value={filters[col.field] || ""}
                  onChange={(e) =>
                    handleFilterChange(col.field, e.target.value)
                  }
                  className="filter-input"
                />
              </div>
            ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowFilterModal(false)}>{inventoryText("inventory.Close")}</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default InventoryTable;
